import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
function GoogleSuccess() {
  const navigate = useNavigate();
  const { login } = useAuth();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const user = params.get("user");
    if (!token || !user) {
      navigate("/");
      return;
    }
    login(JSON.parse(decodeURIComponent(user)), token);
    navigate("/home", { replace: true });
  }, [navigate, login]);
  return <p>Signing you in with Google...</p>;
}
export default GoogleSuccess;